import React from 'react'
import PagesLayout from '..'

export default function PartnersPage() {
  return (
    <PagesLayout
      title="Parceiros"
      description="Estreitamos caminhos para a entregua de mensagens de condolências"
    >
      <br />
      <br />
      <br />
      Em desenvolvimento.
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </PagesLayout>
  )
}
